import { useNavigate, Link } from 'react-router-dom';
import '../Login/style.css';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useErrorHandler } from '../../hooks';
import logo from '../../Assets/Images/logo.png';
import ReactLoading from 'react-loading';
import useToggle from '../../hooks/use-toggle';
import {
  Box,
  Button,
  FormHelperText,
  Typography,
  Grid,
  IconButton,
  FormLabel,
} from '@mui/material';

import CustomTextField from "../../Components/TextField";
import { useDispatch, useSelector } from "react-redux";
import {
  LoginAction,
  ClearAuthResponse,
} from '../../Redux/Actions/AuthActions';
import { useEffect, useRef } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import HelmetReact from '../../Components/Helmet';
export const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { severity, message } = useSelector((state) => state.Toast);
  const { loading } = useSelector((state) => state.Auth);
  const { setMsgConfig } = useErrorHandler();
  const [visiblePassword, setVisiblePassword] = useToggle(true);
  const { user } = useSelector((state) => state?.Auth);
  const loginBtn = useRef(null);

  //handling form and validate data using yup validation
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      email: yup
        .string()
        .required('Please Enter email')
        .email()
        .matches(
          /^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/,
          'please enter valid email'
        ),
      password: yup
        .string()
        .required('Please Enter Password')
        .min(3, 'characters must be more than 3')
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
          'Password must have 8 characters,1 special character,1 UpperCase letter,1 LowerCase letter'
        ),
    }),
    onSubmit: (values) => {
      let payload = {
        email: formik.values.email,
        password: formik.values.password,
      };
      !loading && 
      dispatch(LoginAction(payload));   
        setMsgConfig({
          alertOpen: true,
          message: message,
          severity: severity,
          autoHideDuration: 1000,
        });
    },
  });

  useEffect(() => {
    dispatch(ClearAuthResponse());
  }, [dispatch]);
  useEffect(() => {
    dispatch(ClearAuthResponse());
  }, []);

  useEffect(() => {
    document.addEventListener('keypress', handleKeyPress, true);
  }, []);
  const handleKeyPress = (event) => {
    if (event?.key == 'Enter') {
      loginBtn?.current?.click();
    }
  };
  useEffect(() => {
    message === 'Welcome to ONCIO!' && !user?.role === 'editor' ? navigate('/dashboard') : user?.role === 'editor' ? navigate('/programs') : navigate('/login');
  }, [message]);

  return (
    <>
      <HelmetReact name="Login" />
      <Box className="loginForm">
        <Box className="form-contianer">
          <Box className="logo">
            <img src={logo} className="brand-logo" alt=""></img>
          </Box>
          <Typography className="lable login-header" variant="h3">
            Sign Into Your Account
          </Typography>

          <Box className="input login-input error_message">
            <FormLabel sx={{ display: 'flex' }}>Email*</FormLabel>

            <CustomTextField
              fieldType="simpleTextInput"
              name="email"
              required
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder={'Enter email *'}
              error={formik.touched.email && formik.errors.email ? true : false}
            />
            {formik.touched.email && formik.errors.email && (
              <FormHelperText className="error_message">
                {formik.errors.email}
              </FormHelperText>
            )}
          </Box>
          <Box className="input login-input">
            <FormLabel sx={{ display: 'flex' }}>Password*</FormLabel>

            <CustomTextField
              type={visiblePassword ? 'password' : 'text'}
              fieldType="simpleTextInput"
              required
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder={'Enter password *'}
              error={
                formik.touched.password && formik.errors.password ? true : false
              }
            />
            <IconButton
              className="toggle-eye sign-in-toggle-eye"
              onClick={setVisiblePassword}
            >
              {visiblePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
            {formik.touched.password && formik.errors.password && (
              <FormHelperText className="error_message">
                {formik.errors.password}
              </FormHelperText>
            )}
          </Box>
          <Box className="form-custom-btn login-button">
            <Button
              variant="contained"
              onClick={formik.handleSubmit}
              onKeyDown={handleKeyPress}
              ref={loginBtn}
            >
              {loading ? (
                <Box className="outer_loader">
                  <ReactLoading
                    type={'spinningBubbles'}
                    height="30px"
                    width="30px"
                    color="#FFFFFF"
                  />
                </Box>
              ) : (
                'Login'
              )}
            </Button>
            <Grid className="link-custom" container>
              <Grid item xs className="forget-p">
                <Link to="/forget-password" variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item className="signup-m">
                <Link to="/register" variant="body2">
                  Don't have an account? Sign Up
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};
